<template>
  <div class="container-nameinput">
    <div class="input">
      <i :class="['ui', 'microphone', 'icon', { 'microphone-active': isListening }]"></i>
      <input type="text" id="name-input" ref="nameInput" :placeholder="placeholder" autocomplete="off" style="text-transform: uppercase;"
      :value="name"
      @keydown="typing()"
      @input="name = $event.target.value">
    </div>
    <div v-if="error_message" class="error-panel">{{ error_message }}</div>
    <div class="btn-group-center">
      <div class="btn btn-large" ref="btnRepeat" @click="repeatSpeak()">
        <i class="undo alterante icon"></i>
        <span>Repetir</span>
      </div>
      <div :class="confirmDisabled == true ? 'btn btn-large isDisabled' : 'btn btn-large'" id="btn-confirm" ref="btnConfirm"
      @click="searchCustomer()">
        <i class="check icon"></i>
        <span>Confirmar</span>
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      timerTyping: null,
      speechTimer: null,
      recognitionInstance: null,
      isListening: false,
      placeholder: 'Por favor, fale seu nome completo',
      name: '',
      msg: 'Por favor, fale seu nome completo.',
      toggle: false,
      speaking: false,
      lang: 'pt-BR',
      runtimeTranscription: '',
      sentences: [],
      count: 1,
      confirmDisabled: true,
      findCustomer: true,
      is_loading: false,
      error_message: ''
    }
  },
  computed: {
    nameUppercase(value) {
      return value.toUpperCase();
    }
  },
  mounted() {
    this.speak(this.msg);
    this.count = this.count + 1;
    // recognition
  },
  beforeDestroy() {
    if (this.timerTyping) clearTimeout(this.timerTyping);
    if (this.speechTimer) clearTimeout(this.speechTimer);
    if (this.recognitionInstance) {
      const recognition = this.recognitionInstance;
      this.recognitionInstance = null;
      recognition.stop();
    }
    this.isListening = false;
  },
  methods: {
    typing() {
      console.log('typing')
      var app = this;
      clearTimeout(this.timerTyping);
      this.error_message = '';
      this.timerTyping = setTimeout(function() {
        app.confirmDisabled = false;
      }, 3000);
    },
    textUppercase(value) {
      return value.toUpperCase();
    },
    backClicked(section) {
      this.$emit('backClicked', section);
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    falar() {
      if (this.count <= 3) {
        this.count += 1;
        this.toggle = true;
        let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
        if (!SpeechRecognition) {
          console.error('Reconhecimento de voz indisponível neste navegador.');
          this.toggle = false;
          return;
        }
        let recognition = new SpeechRecognition()
        this.recognitionInstance = recognition;
        recognition.lang = this.lang;
        recognition.interimResults = true;

        recognition.addEventListener('start', () => {
          if (this.recognitionInstance === recognition) this.isListening = true;
        });

        recognition.addEventListener('error', err => {
          console.error('Erro no reconhecimento de voz:', err);
          if (this.recognitionInstance === recognition) this.isListening = false;
        });

        recognition.addEventListener('speechstart', event => {
          this.speaking = true
        });

        recognition.addEventListener('speechend', event => {
          this.speaking = false
        });

        recognition.addEventListener('result', event => {
          //console.log(event);
          const text = Array.from(event.results).map(result => result[0]).map(result => result.transcript).join('');
          this.runtimeTranscription = text;
          //console.log(text);
        });

        recognition.addEventListener('end', () => {
          if (this.recognitionInstance !== recognition) return;
          this.isListening = false;
          this.recognitionInstance = null;
          if (this.runtimeTranscription !== '') {
            this.sentences.push(this.runtimeTranscription);
            //console.log(this.sentences);
            this.name = this.runtimeTranscription.toUpperCase();
            //this.$emit('update:text', `${this.text}${this.sentences.slice(-1)[0]}. `)
            this.confirmDisabled = false;
          };
          this.runtimeTranscription = '';
          this.toggle = false;

          /* if (this.toggle) {
            // keep it going.
            recognition.start();
          }; */
        });

        try {
          recognition.start();
        } catch (err) {
          this.isListening = false;
          this.recognitionInstance = null;
          this.toggle = false;
          console.error('Não foi possível iniciar o reconhecimento de voz:', err);
        }
      } else {
        console.log('abrir teclado');
        this.$refs.nameInput.$el.focus();
      }
    },
    repeatSpeak() {
      if (this.recognitionInstance) {
        const recognition = this.recognitionInstance;
        this.recognitionInstance = null;
        recognition.stop();
      }
      this.isListening = false;
      this.runtimeTranscription = '';
      this.name = '';
      this.sentences = [];
      this.confirmDisabled = true;
      if (this.count <= 3) {
        this.speak(this.msg);
      } else {
        this.placeholder = 'Por favor, digite seu nome completo'
        this.$refs.btnRepeat.style.opacity = .2;
        this.confirmDisabled = true;
        $('#name-input').focus();
        console.log('abrir teclado');
        this.speak(this.placeholder);
      };
    },
    useKeyboard() {
      alert('abrir teclado');
    },
    speak(msg) {
      var app = this;
      if (this.speechTimer) clearTimeout(this.speechTimer);
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      var voice_br = {};
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      if (this.count <= 3) {
        window.speechSynthesis.speak(utterThis);
        this.speechTimer = setTimeout(function() {
          app.speechTimer = null;
          app.falar();
        }, 3000);
      } else {
        window.speechSynthesis.speak(utterThis);
      };
    },
    async searchCustomer() {
      if (this.confirmDisabled || this.is_loading) return;
      var name = this.name.toUpperCase();
      if (name.trim().length < 3) {
        this.error_message = 'Informe pelo menos três letras do nome.';
        return;
      }
      this.is_loading = true;
      this.confirmDisabled = true;
      this.error_message = '';
      this.$emit('setCustomerName', name);
      if (this.findCustomer) {
        try {
          const { data } = await axios.get('api/kiosk/customers/search/' + encodeURIComponent(name));
          if (data.data.length != 0) {
            this.$emit('buttonClicked', 'CustomerIdent');
            this.$emit('foundCustomer', data.data);
            this.$emit('setMeta', data.links);
          } else {
            this.$emit('buttonClicked', 'TakePicture');
          }
        } catch (err) {
          this.error_message = 'Não foi possível pesquisar o paciente. Verifique a conexão e tente novamente.';
          this.confirmDisabled = false;
        } finally {
          this.is_loading = false;
        }
      };
    }
  }
}
</script>
<style scoped>
.container-nameinput {
  position: absolute;
  top: 90%;
  left: 25%;
  width: 100%;
  margin: -24% 0 0 -25%;
  /* border: 1px solid red; */
}
.input {
  width: 90%;
  height: 80px;
  margin: 0 auto;
  padding: 0px 40px;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
.input i {
  position: relative;
  float: left;
  top: 30px;
  font-size: 32px;
  color: #666;
}
.input i.microphone-active {
  color: #e53935;
}
input {
  float: left;
  width: 80%;
  height: -webkit-fill-available;
  margin-left: 30px;
  font-size: 32px;
  border: none;
  outline: none;
}
.btn span {
  width: inherit;
}
.btn-group-center {
  display: flex;
  width: fit-content;
  margin: 0 auto;
  margin-top: 12px;
}
.btn-large {
  width: 260px;
  height: 80px;
  margin: 0 10px;
  padding: 0 20px;
}
.btn-large i {
  font-size: 26px;
  padding: 4px 0px 0px 30px;
}
.btn-large span {
  padding-left: 38px;
  font-size: 32px;
}
#back-btn {
  align-items: center;
  justify-content: center;
}
.isDisabled {
  opacity: .2;
}
</style>



// WEBPACK FOOTER //
// src/components/NameInput.vue